import { EngineExceptionEnum } from "@/enum/exception-list";
import { useGetEngineHistoryQuery } from "@/services/engine-history";
import { Load } from "components/load";
import PageError from "components/page-error";
import { Download, RefreshCw } from "lucide-react";
import React, { useState } from "react";
import { columns } from "../components/columns";
import { DataTable } from "../components/data-table";
import { useFilterEngineHistoryState } from "../duck/hook/state";
import { Button } from "components/ui/button";
import { ExportDialog } from "../components/export-dialog";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export const EngineHistory: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const filterState = useFilterEngineHistoryState();

  const baseFilters = {
    meta: {
      page: filterState.filters.meta?.page || 1,
      perPage: filterState.filters.meta?.perPage || 10,
    },
  };

  const dynamicFilters = Object.entries(filterState.filters).reduce(
    (acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        acc[key] =
          key === "type_solicitation"
            ? (value as EngineExceptionEnum)
            : key === "type_request"
            ? (value as EngineExceptionEnum)
            : value;
      }
      return acc;
    },
    {} as Record<string, unknown>
  );

  const filters = { ...baseFilters, ...dynamicFilters };

  const {
    data: engineHistory,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useGetEngineHistoryQuery(filters);

  const { data, meta } = engineHistory || {
    data: [],
    meta: { page: 1, perPage: 10, total: 0, totalPages: 0 },
  };
  const handleOpenModal = () => setIsOpen(true);

  if (isLoading) return <Load />;
  if (error) return <PageError status={500} message="Erro ao buscar dados" />;
  return (
    <PageLayout>
      <PageTitle
        title="Histórico de Solicitações Fiscais"
        description="Gerencie as solicitações fiscais dos usuários"
      />
      <ContentContainer>
        <div className="flex flex-row gap-2 justify-end mb-2">
          <Button
            className="px-4 py-2 border border-gray-300 flex items-center gap-2 rounded-md
                    text-gray-700 bg-white
                    transition-all duration-300 ease-in-out
                    hover:bg-gray-100 hover:border-gray-400
                    focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
            onClick={() => refetch()}
            disabled={isLoading}
          >
            <RefreshCw className="w-5 h-5" />
            Atualizar dados
          </Button>
        </div>
        <DataTable data={data} meta={meta} columns={columns} isLoading={isFetching} />
        <div className="flex flex-row gap-2 justify-end mt-4">
          <Button
            className="flex flex-row gap-2 w-48"
            onClick={handleOpenModal}
          >
            <Download className="w-5 h-5" /> Exportar Relatório
          </Button>
        </div>
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogContent className="sm:max-w-[600px] overflow-visible">
            <ExportDialog onCloseModal={() => setIsOpen(false)} />
          </DialogContent>
        </Dialog>
      </ContentContainer>
    </PageLayout>
  );
};
